/**
 * Dispensa da faixa "atualize o app", no molde do `InstallPrompt`.
 *
 * A chave é o `notice_id` que o BACKEND manda (`ios:soft:1.2`) — não uma
 * constante versionada à mão. Quando o operador sobe a versão recomendada no
 * admin, o `notice_id` muda e a faixa **reaparece sozinha**, sem ninguém
 * lembrar de bumpar um `-v3` no código (o que o `InstallPrompt` teve que fazer
 * na mão em 2026-07-05).
 *
 * O bloqueio duro NUNCA consulta isto — não é dispensável.
 */

const DISMISS_PREFIX = 'bow-update-dismissed:';
const DISMISS_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 dias

function key(noticeId: string): string {
  return `${DISMISS_PREFIX}${noticeId}`;
}

export function recentlyDismissed(
  noticeId: string | null | undefined,
  now: number = Date.now()
): boolean {
  if (!noticeId) return false;
  try {
    const raw = window.localStorage.getItem(key(noticeId));
    if (!raw) return false;
    const ts = Number(raw);
    // localStorage com lixo (outra versão do app, usuário mexendo) não pode
    // engolir a faixa pra sempre — valor ilegível conta como "não dispensado".
    if (!Number.isFinite(ts)) return false;
    return now - ts < DISMISS_TTL_MS;
  } catch {
    // Safari em modo privado pode lançar no acesso ao storage.
    return false;
  }
}

export function markDismissed(
  noticeId: string | null | undefined,
  now: number = Date.now()
): void {
  if (!noticeId) return;
  try {
    window.localStorage.setItem(key(noticeId), String(now));
  } catch {
    // Sem storage, a faixa volta na próxima abertura. Aceitável.
  }
}
